/**
 * Created by Jerker Nord on 2018-05-31.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {IceIceYetiGameAssets} from "../IceIceYetiGameAssets";

export class StickySymbol extends PIXI.Container {

    private _stickySymbolName:string;
    private _firstFreeze:boolean;
    private _symbolFreezeAnimation:TimelineSprite;
    private _generalFreezeAnimation:TimelineSprite;

    constructor(stickySymbolName:string) {
        super();
        this._stickySymbolName = stickySymbolName;
        this._firstFreeze = true;
        this._symbolFreezeAnimation = new TimelineSprite(GameResources.getTextures(this._stickySymbolName + "/freezeAnimation/" + this._stickySymbolName + "_freeze_"));
        this._symbolFreezeAnimation.anchor.set(0.5, 0.5);
        this._symbolFreezeAnimation.show();
        this._symbolFreezeAnimation.alpha = 0;
        this.addChild(this._symbolFreezeAnimation);

        this._generalFreezeAnimation = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.GENERAL_SYMBOL_FREEZE));
        this._generalFreezeAnimation.anchor.set(0.5, 0.5);
        this._generalFreezeAnimation.show();
        this._generalFreezeAnimation.visible = false;
        this.addChild(this._generalFreezeAnimation);
    }

    public getFreezeAnimation(isRestore:boolean = false):TimelineLite {
        const freezeAnimationTL:TimelineLite = new TimelineLite({paused : true});
        if(isRestore == true) {
            freezeAnimationTL.add([
                () => this._firstFreeze = false,
                () => this._symbolFreezeAnimation.alpha = 1,
                this._symbolFreezeAnimation.getAnimation().totalProgress(1, false)
            ]);
        } else {
            freezeAnimationTL.add([
                () => this._firstFreeze = false,
                () => this._generalFreezeAnimation.visible = true,
                new TweenLite(this._symbolFreezeAnimation, 0.1, {alpha : 1}),
                this._symbolFreezeAnimation.getAnimation(),
                this._generalFreezeAnimation.getAnimation()
            ]);
            freezeAnimationTL.add(() => this._generalFreezeAnimation.visible = false);
        }
        return freezeAnimationTL;
    }

    get firstFreeze():boolean {
        return this._firstFreeze;
    }

    get stickySymbolName():string {
        return this._stickySymbolName;
    }
}